import React, {useState, useEffect} from 'react';
import "./ReportOrders.css";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import Grid from "@mui/material/Grid";
import DatePicker from "react-datepicker2";
import {strings} from "../../../strings";
import Button from "@mui/material/Button";
import {selToken} from "../../../stores/base/baseSlice";
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";


const initialState = {
    fromDate: "",
    toDate: "",
    fromDateForSend: "",
    toDateForSend: "",
};

export default function ReportOrders() {


    const mToken = useSelector(selToken);

    const [{fromDate, toDate, fromDateForSend, toDateForSend},
        setStaticState] = useState(initialState);


    const forms = [
        {
            label: "از تاریخ",
            value: fromDate,
            name: "fromDate",
        },
        {
            label: "تا تاریخ",
            value: toDate,
            name: "toDate",
        },
    ];

    async function getReport() {
        await axios({
            method: 'post',
            url: strings.baseUrl + `admin/order/print/report`,
            data:{
                from_date: fromDateForSend,
                to_date: toDateForSend,
            },
            headers: {
                "Authorization": `Bearer ${mToken}`
            }
        })
            .then(result=>{
                if(result.data.status_code === 200){
                    let data = decodeURIComponent(escape(window.atob( result.data.data.barcode_images )));
                    let w = window.open();
                    w.document.write(data);
                    w.print();
                    w.close();
                }else alert("خطایی رخ داد");
            })
            .catch(error=>{
                console.log(error)
            })
    }

    function setParametersStatic(event, name) {
        // const {value, name} = event.target;
        setStaticState(prevState => ({
            ...prevState, [name]: event.format(`jYYYY/jMM/jDD HH:mm:ss`),
            [`${name}ForSend`]: event.format(`jYYYY-jMM-jDD HH:mm`)
        }));
    }

    useEffect(() => {

    }, []);


    return (
            <Grid item lg={12} className="w-100 d-flex flex-column DivParentCreateProduct">
                <ContainerHeader
                    data={{
                        filter: false,
                        addBtn: false,
                    }}
                    headerTitle="گزارش سفارشات"
                    // filterAction={(value) => {
                    //     handleSearch(value);
                    // }}
                />
                <Paper className="d-flex flex-column divParentContentBasicInformation mt-2 pt-3">
                    <div className="d-flex">
                        {forms.map((item, i) => (
                            <Grid item key={i}
                                  lg={4}
                                  className="d-flex justify-content-center align-items-center"
                            >
                                <div
                                    className={`ContentCreateAttribute parentBoxDatepicker w-100`}
                                >
                                    <span>{item.label}</span>
                                    <DatePicker
                                        isGregorian={false}
                                        className="DatePickerCreateProduct"
                                        onChange={(e) => setParametersStatic(e, item.name)}
                                    />
                                </div>
                            </Grid>
                        ))}
                    </div>
                    <div className="my-4">
                        <Button
                            variant="contained"

                            className="continuationButtonCreateProduct ml-3 mr-4"
                            // disabled={allSlider !== null && allSlider.length === 0}
                            // onClick={``}
                            onClick={()=>getReport()}
                        >
                            پرینت فاکتور
                        </Button>
                    </div>
                </Paper>
            </Grid>
    );
}